import { CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React, { createRef, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FilterMenu } from './Menu';
import { LayerCloseHandle } from '../types/layers';
import { FilterButtons } from './FilterButtons';
import useFiltersQuery from '../api/use-filters-query';
import { useFiltering } from '../utils/use-filtering';
import { getTranslations } from '../translations';

const FilterMenuWrapper = styled.div`
`;

const FilterContentContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  position: relative;
`;

const CloseWrapper = styled.div`
  padding: ${props => props.theme.size.dynamic0020};
  justify-self: end;
`;

interface Props {
  close: LayerCloseHandle;
};

export default ({ close }: Props) => {
  const { aria } = getTranslations();

  const sectionRef = createRef<HTMLDivElement>();
  const [sectionHeight, setSectionHeight] = useState(0);

  const { isSuccess } = useFiltersQuery();
  const { selectAppliedFilters } = useFiltering();

  const handleClose = () => {
    close();
  };

  const setHeight = useCallback(() => {
    if (sectionRef?.current) {
      const offsetTop = sectionRef?.current?.offsetTop;
      const offsetHeight = sectionRef?.current?.offsetHeight;
      const height = offsetTop + offsetHeight;
      setSectionHeight(height);
    }
  }, [sectionRef]);

  const resizeObserver = new ResizeObserver(setHeight);


  useEffect(() => {
    if (isSuccess && sectionRef?.current) {
      setHeight();
      resizeObserver.observe(sectionRef?.current);
    }
  }, [isSuccess, sectionRef]);

  useEffect(() => {
    selectAppliedFilters();
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <FilterMenuWrapper aria-describedby="filters_panel_header">
      <FilterContentContainer ref={sectionRef}>
        <CloseWrapper>
          <CTA
            tag="button"
            emphasis="none"
            onClick={handleClose}
            ariaLabel={aria.close}
            icon={<Close variant="default" ariaHidden />}
            iconPosition="top"
          />
        </CloseWrapper>
        <FilterMenu />
      </FilterContentContainer>
      <FilterButtons close={close} sectionHeight={sectionHeight} />
    </FilterMenuWrapper>
  );
};
